import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import RequiredIndicator from "../Form/RequiredIndicator";
import NumberFormat from "react-number-format";

const PhoneInput = (props) => {
	const {
		name,
		type,
		label,
		touched,
		error,
		required,
		onChange,
		onBlur,
		nullable,
		classes,
		...attributes
	} = props;
	const inputId = `input-${name.replace(/\./g, "-")}`;

	const valid = required & touched && !error ? true : false;
	const invalid = required & touched && error ? true : false;
	const requiredIndicator = nullable ? false : true;

	return (
		<FormGroup>
			<Label for={inputId}>
				{label} {requiredIndicator && required && <RequiredIndicator />}
			</Label>
			<NumberFormat
				customInput={Input}
				format="1 (###) ###-####"
				type={type}
				name={name}
				id={inputId}
				onChange={onChange}
				onBlur={onBlur}
				invalid={invalid}
				valid={valid}
				className={classes}
				{...attributes}
			/>
			{required && invalid && (
				<FormFeedback valid={valid}>{error}</FormFeedback>
			)}
		</FormGroup>
	);
};

PhoneInput.defaultProps = {
	placeholder: "",
	touched: false,
	error: false,
	required: false,
	maxLength: undefined,
	data: [],
};

export default PhoneInput;
